import { render, staticRenderFns } from "./FrontServiceLeaveRecord.vue?vue&type=template&id=2e127a67&scoped=true"
import script from "./FrontServiceLeaveRecord.vue?vue&type=script&lang=js"
export * from "./FrontServiceLeaveRecord.vue?vue&type=script&lang=js"
import style0 from "./FrontServiceLeaveRecord.vue?vue&type=style&index=0&id=2e127a67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e127a67",
  null
  
)

export default component.exports